module.exports = __webpack_public_path__ + "static/media/notification-green.96abafcb.svg";